// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3Qn_g","header":"Messages_header__39j9r"};